import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ResetButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: 0,
  marginRight: theme.spacing(2),
  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
  },
}));

export default ResetButton;
